export const withInternetCheck = (navigator: any, fn: any, args: any, offlineFn?: any) => {
  if (navigator && navigator.onLine) {
    fn(args);
  }

  if (navigator && !navigator.onLine) {
    offlineFn();
  }
};

export const getExpiryDate = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  const expiryDate = date;

  return expiryDate;
};

export const apiUrl = "https://aao-api.ibee.ai";

export const websiteName = "AAONXT - Partners";

export const isValidDriveLink = (url) => {

  return url.startsWith("https://");
};

export const convertStringToBoolean = (str) => {
  return str?.toLowerCase() === "true";
}

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
};

export const isValidPhoneNumber = (number) => {
  const phoneRegex = /^\+?[1-9]\d{1,14}$/;

  return phoneRegex.test(number);
};

export const formatDate = (isoString: string) => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}